import { NotificationDto } from '@careapp-group/ng-sdk';
import { CareAppListActionFactory } from '../action-factory';

class NotificationsActions extends CareAppListActionFactory<NotificationDto> {
  constructor(modelName: string) {
    super(modelName);
  }
  get REQUEST_DISMISS_NOTIFICATION() {
    return `[${this.type}][Request] Dismiss notification`;
  }
  get RESPONSE_SUCCESS_DISMISS_NOTIFICATION() {
    return `[${this.type}][Response][Success] Dismiss notification`;
  }
  get RESPONSE_FAIL_DISMISS_NOTIFICATION() {
    return `[${this.type}][Response][Fail] Dismiss notification`;
  }
  get REQUEST_DISMISS_ALL_NOTIFICATIONS() {
    return `[${this.type}][Request] Dismiss all notifications`;
  }
  get RESPONSE_SUCCESS_DISMISS_ALL_NOTIFICATIONS() {
    return `[${this.type}][Response][Success] Dismiss all notifications`;
  }
  get RESPONSE_FAIL_DISMISS_ALL_NOTIFICATIONS() {
    return `[${this.type}][Response][Fail] Dismiss all notifications`;
  }
  get REQUEST_UNSEEN_NOTIFICATION_COUNT() {
    return `[${this.type}][Request] Unseen notification count`;
  }
  get RESPONSE_SUCCESS_UNSEEN_NOTIFICATION_COUNT() {
    return `[${this.type}][Response][Success] Unseen notification count`;
  }
  get RESPONSE_FAIL_UNSEEN_NOTIFICATION_COUNT() {
    return `[${this.type}][Response][Fail] Unseen notification count`;
  }
  get REQUEST_SET_NOTIFICATION_READ() {
    return `[${this.type}][Request] Set as read`;
  }
  get RESPONSE_SUCCESS_SET_NOTIFICATION_READ() {
    return `[${this.type}][Response][Success] Set as read`;
  }
  get RESPONSE_FAIL_SET_NOTIFICATION_READ() {
    return `[${this.type}][Response][Fail] Set as read`;
  }

  RequestDismissAllNotifications() {
    return {
      type: this.REQUEST_DISMISS_ALL_NOTIFICATIONS,
    };
  }

  ResponseSuccessDismissAllNotifications() {
    return {
      type: this.RESPONSE_SUCCESS_DISMISS_ALL_NOTIFICATIONS,
    };
  }
  ResponseFailDismissAllNotifications(payload: any) {
    return {
      type: this.RESPONSE_FAIL_DISMISS_ALL_NOTIFICATIONS,
      payload,
    };
  }

  RequestDismissNotification(payload: { id: string }) {
    return {
      type: this.REQUEST_DISMISS_NOTIFICATION,
      payload,
    };
  }

  ResponseSuccessDismissNotification(payload: NotificationDto) {
    return {
      type: this.RESPONSE_SUCCESS_DISMISS_NOTIFICATION,
      payload,
    };
  }
  ResponseFailDismissNotification(payload: any) {
    return {
      type: this.RESPONSE_FAIL_DISMISS_NOTIFICATION,
      payload,
    };
  }

  RequestUnseenNotificationCount() {
    return {
      type: this.REQUEST_UNSEEN_NOTIFICATION_COUNT,
    };
  }

  ResponseSuccessUnseenNotificationCount(payload: number) {
    return {
      type: this.RESPONSE_SUCCESS_UNSEEN_NOTIFICATION_COUNT,
      payload,
    };
  }
  ResponseFailUnseenNotificationCount(payload: any) {
    return {
      type: this.RESPONSE_FAIL_UNSEEN_NOTIFICATION_COUNT,
      payload,
    };
  }

  RequestSetAsRead(payload: { id: string }) {
    return {
      type: this.REQUEST_SET_NOTIFICATION_READ,
      payload,
    };
  }

  ResponseSuccessSetAsRead(payload: NotificationDto) {
    return {
      type: this.RESPONSE_SUCCESS_SET_NOTIFICATION_READ,
      payload,
    };
  }
  ResponseFailSetAsRead(payload: any) {
    return {
      type: this.RESPONSE_FAIL_SET_NOTIFICATION_READ,
      payload,
    };
  }
}

export const Notifications = new NotificationsActions(`Notifications`);
